window.S23CitySearch = (urls) => {
  const cache=new Map();
  const normalize=s=>s.toLocaleLowerCase().normalize('NFD').replace(/\p{M}/gu,'').replace(/[^\p{L}\p{N}\s]/gu,' ').trim().replace(/\s+/g,' ');
  async function load(key){
    if(!cache.has(key))cache.set(key,(async()=>{
      return (await Promise.all(urls[key].map(async url=>{
      const response=await fetch(url);if(!response.ok)throw new Error('Location search unavailable');
      const data=await response.json();
      const bytes=Uint8Array.from(atob(data.gzip),c=>c.charCodeAt(0));
      return await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))).json();
      }))).flat();
    })().catch(error=>{cache.delete(key);throw error;}));
    return cache.get(key);
  }
  return async query=>{
    const needle=normalize(query),tokens=needle.split(' ');
    if(needle.length<2)return [];
    const key=/^[a-z]/.test(needle)?needle[0]:'other';
    const records=await load(key),matches=[];
    for(const r of records){
      let score=0;
      for(const name of r[4]){
        if(!name.startsWith(tokens[0]))continue;
        const searchable=name+' '+r[5];
        if(!tokens.every(t=>searchable.split(' ').some(w=>w.startsWith(t))))continue;
        let rank=name===needle?4:name.startsWith(needle)?3:needle.startsWith(name+' ')?2:1;
        score=Math.max(score,rank);
      }
      if(score)matches.push({r,score});
    }
    return matches.sort((a,b)=>b.score-a.score||b.r[6]-a.r[6]).slice(0,8).map(m=>m.r.slice(0,4));
  };
};
